export default "__VITE_ASSET__C5ga9bam__"